module.exports = __webpack_public_path__ + "../static/img/kairos_logo.7d43366b.png";